import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
import moment from 'moment';
//import jobmixin from '@/helpers/Mixins/JobMixin.js';
export default {
    methods: {
        async getAppointmentsByDateOrRange(inDate1, inDate2, includeJobs) {
            var meta = { clientApiMethod: 'getAppointmentsByDateOrRange', input: { inDate1, inDate2, includeJobs } }
            var date1string = "?date1=" + moment(inDate1).format('YYYY-MM-DDTHH:mm:ss')
            var date2string = inDate2 ? "&date2=" + moment(inDate2).format('YYYY-MM-DDTHH:mm:ss') : '';
            var includeJobsstring = includeJobs ? "&includeJob=true" : '';
            var response = await client().get('/api2/ServiceProvider/' + "Appointment/DateRange/" + date1string + date2string + includeJobsstring, { meta: meta })
            return response?.data;
        },
        async getAppointmentsByJobId(jobId) {
            var meta = { clientApiMethod: 'getAppointmentsByJobId', input: { jobId: jobId } }
            var response = await client().get(store.state.apiRouteRoot + "Appointment/job/" + jobId, { meta: meta })
            return response?.data;
        },
        async getAppointment(appointmentId) {
            var meta = { clientApiMethod: 'getAppointment', input: { appointmentId: appointmentId } }
            var response = await client().get(store.state.apiRouteRoot + "Appointment/get/" + appointmentId, { meta: meta })
            return response?.data;
        },
        async createAppointment(newAppointment) {
            var meta = {
                clientApiMethod: 'createAppointment',
                input: { newAppointment },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.appointment.appointment") })
            }
            var response = await client().post(store.state.apiRouteRoot + 'Appointment/create', newAppointment, { meta: meta })
            return response?.data;
        },
        async changeAppointment(updatedAppointment) {
            var meta = {
                clientApiMethod: 'changeAppointment',
                input: { updatedAppointment },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.appointment.appointment") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'Appointment/change', updatedAppointment, { meta: meta })
            return response?.data;
        },
        async deleteAppointment(appointmentId) {
            var meta = {
                clientApiMethod: 'deleteAppointment',
                input: { appointmentId: appointmentId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.appointment.appointment") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "Appointment/delete/" + appointmentId, { meta: meta })
            return response?.data;
        },
        async getAvailableUsers(wrapperAppointent) {
            var meta = { clientApiMethod: 'getAvailableUsers', input: { wrapperAppointent: wrapperAppointent } }
            var response = await client().post(store.state.apiRouteRoot + "Appointment/available", wrapperAppointent, { meta: meta })
            return response?.data;
        },
        async getBookableUsers() {
            var response = await client().get(store.state.apiRouteRoot + "Appointment/bookable", { meta: { clientApiMethod: 'getBookableUsers' } })
            return response?.data;
        },
        async getSchedulerDtoForDateRange(inDate1, inDate2) {
            var meta = { clientApiMethod: 'getSchedulerDtoForDateRange', input: { inDate1: inDate1, inDate2: inDate2 } }
            var date1string = "?date1=" + moment(inDate1).format('YYYY-MM-DDTHH:mm:ss')
            var date2string = inDate2 ? "&date2=" + moment(inDate2).format('YYYY-MM-DDTHH:mm:ss') : '';
            var response = await client().get(store.state.apiRouteRoot + "Scheduler/DateRange/" + date1string + date2string, { meta: meta })
            return response?.data;
        },
        async getAppointmentAsSchedulerDtos(appointmentId) {
            var meta = { clientApiMethod: 'getAppointmentAsSchedulerDtos', input: { appointmentId: appointmentId } }
            var response = await client().get(store.state.apiRouteRoot + "Scheduler/Events/" + appointmentId, { meta: meta })
            return response?.data;
        },
        async getResourceList() {
            var meta = { clientApiMethod: 'getResourceList', input: {} }
            var response = await client().get(store.state.apiRouteRoot + "Scheduler/Resources", { meta: meta })
            return response?.data;
        },
        async changeEventTimes(updatedAppointment) {
            var meta = {
                clientApiMethod: 'changeAppointment',
                input: { updatedAppointment },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.appointment.appointment") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'Scheduler/Events/ChangeTimes', updatedAppointment, { meta: meta })
            return response?.data;
        },
    }
}